module.exports = __webpack_public_path__ + "files/4df93897de65338b59a26912115e5d68.png";